import { render, staticRenderFns } from "./LayoutSidenav.vue?vue&type=template&id=e80d2c9e&scoped=true&"
import script from "./LayoutSidenav.vue?vue&type=script&lang=js&"
export * from "./LayoutSidenav.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSidenav.vue?vue&type=style&index=0&id=e80d2c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80d2c9e",
  null
  
)

export default component.exports